module.exports = __webpack_public_path__ + "static/media/tm6_2.0a1eb231.svg";